function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M466.204,87.792L381.417,3.125c-4.173-4.167-10.932-4.167-15.105,0c-4.173,4.167-4.173,10.917,0,15.083L379.122,31 l-70.35,70.25l-44.855-44.792c-4.173-4.167-10.932-4.167-15.105,0c-4.173,4.167-4.173,10.917,0,15.083L273.305,96L67.22,301.792 c-2.003,2-3.129,4.708-3.129,7.542c0,22.622,8.202,43.164,21.358,59.589l-82.32,82.203c-4.173,4.167-4.173,10.917,0,15.083 c2.086,2.083,4.819,3.125,7.552,3.125c2.733,0,5.466-1.042,7.552-3.125l82.32-82.203c16.448,13.138,37.019,21.328,59.673,21.328 c2.837,0,5.55-1.125,7.552-3.125l206.084-205.792l24.493,24.458c2.086,2.083,4.819,3.125,7.552,3.125s5.466-1.042,7.552-3.125 c4.173-4.167,4.173-10.917,0-15.083l-46.524-46.458l70.35-70.25l13.811,13.792c2.086,2.083,4.819,3.125,7.552,3.125 s5.466-1.042,7.552-3.125C470.376,98.708,470.376,91.958,466.204,87.792z M135.542,327.542c-2.083,2.083-4.813,3.125-7.542,3.125 c-2.729,0-5.458-1.042-7.542-3.125l-19.115-19.115c-4.167-4.167-4.167-10.917,0-15.083c4.167-4.167,10.917-4.167,15.083,0 l19.115,19.115C139.708,316.625,139.708,323.375,135.542,327.542z M167.542,274.208c-2.083,2.083-4.813,3.125-7.542,3.125 c-2.729,0-5.458-1.042-7.542-3.125l-8.448-8.448c-4.167-4.167-4.167-10.917,0-15.083c4.167-4.167,10.917-4.167,15.083,0 l8.448,8.448C171.708,263.292,171.708,270.042,167.542,274.208z M220.875,242.208c-2.083,2.083-4.813,3.125-7.542,3.125 c-2.729,0-5.458-1.042-7.542-3.125l-19.115-19.115c-4.167-4.167-4.167-10.917,0-15.083c4.167-4.167,10.917-4.167,15.083,0 l19.115,19.115C225.042,231.292,225.042,238.042,220.875,242.208z M252.875,188.875c-2.083,2.083-4.813,3.125-7.542,3.125 c-2.729,0-5.458-1.042-7.542-3.125l-8.448-8.448c-4.167-4.167-4.167-10.917,0-15.083c4.167-4.167,10.917-4.167,15.083,0 l8.448,8.448C257.042,177.958,257.042,184.708,252.875,188.875z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgSyringe = function SvgSyringe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.333 469.333",
    style: {
      enableBackground: "new 0 0 469.333 469.333"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSyringe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/syringe.839b0bc8.svg";
export { ForwardRef as ReactComponent };